import React from 'react';
import { Badge, Card, Col } from 'react-bootstrap';
import { 
  FlexibleHeightXYPlot, 
  YAxis, 
  HorizontalGridLines, 
  VerticalBarSeries 
} from 'react-vis';
import { BsCircleFill } from 'react-icons/bs';
import { Link, useParams } from 'react-router-dom';
import DiscoveryTooltip from 'DiscoveryTooltip';
import { uiLabel } from 'Utils';

const BACKGROUND_BAR_TOTAL = [
  {
    x: 0,
    y: 100,
    color: '#D9DDE3'
  }
];

const BACKGROUND_BAR_CATEGORIES = [
  {
    x: 0,
    y: 100,
    color: '#D9DDE3'
  }
];

const COLOR_VALUES = [
  '#315DFF',
  '#7360F6',
  '#00C4F0'
];

const RiskCategories = (props) => {
  const categoryData = props.categoryData || [];
  const totalSensitiveData = props.totalSensitiveData || [];
  const totalPercent = totalSensitiveData[0] && Math.floor(totalSensitiveData[0].y);
  const searchid = props.searchid;
  const { id } = useParams();

  return (
    <div className='d-flex flex-column h-100'>
      <div>
        <h5 className='text-left sg-eyebrow'>Findings by category</h5>
      </div>
      <Card className='flex-grow-1 risk-categories'>
        <div className='d-flex h-100'>
          <div className='h-100 d-flex flex-row align-items-center'>
            <FlexibleHeightXYPlot
              width={115}
              colorType='literal'
              margin={{ bottom: 15, right: 25 }}
            >
              <HorizontalGridLines />
              <YAxis />
              <VerticalBarSeries
                cluster='totals'
                data={BACKGROUND_BAR_TOTAL}
              />
              <VerticalBarSeries
                cluster='totals'
                data={totalSensitiveData}
              />
              <VerticalBarSeries
                cluster='categories'
                data={BACKGROUND_BAR_CATEGORIES}
              />
              { categoryData.map((category, i) => {
                const chartData = category.chartData || [];
                return (
                  <VerticalBarSeries
                    key={i}
                    cluster='categories'
                    data={chartData}
                  />
                )
              })}
            </FlexibleHeightXYPlot>
          </div>
          <div
            className='text-left flex-grow-1 pr-3 pl-3 d-flex flex-column justify-content-center'
            style={{ fontSize: '12px' }}
          >
            {/* <div className='mb-3'>
              <BsCircleFill className='mr-2' color='#315DFF'/>
              {totalPercent}% of scanned data flagged as sensitive
            </div> */}
            <div
              style={{
                borderBottom: '2px solid #D9DDE3',
                fontWeight: '500',
                color: '#8A92A0'
              }}
              className='d-flex w-100 pb-1 mb-2'
            >
              <Col>
                <BsCircleFill className='mr-2' color='#fff' /> CATEGORY
              </Col>
              <Col className='d-flex justify-content-end flex-grow-1'>
                TOP FINDINGS
              </Col>
            </div>
      
            { [...categoryData]
              .sort((a,b) => b.score - a.score)
              .map((obj, i) => {
                const category = obj.category;
                const percent = obj.score || 0;
                const findings = obj.findings && obj.findings.slice(0, 3) || [];
                // const normalizedFindings = normalizeEntityNames(findings);
                if (percent) {
                  return (
                    <div key={i} className='d-flex w-100 mb-2'>
                      <div style={{whiteSpace:'nowrap'}}>
                        <BsCircleFill className='mr-2' color={obj.color} /> {Math.floor(percent)}% <span className='text-capitalize'>{category} </span>
                      </div>
                      <div className='d-flex justify-content-end flex-grow-1 flex-wrap'>
                        { findings.map((finding, i) => (
                          <DiscoveryTooltip
                            key={i}
                            text={`See all locations where ${uiLabel( finding.entity)} elements were found.`}
                            placement='top'
                          >
                            <Link
                              to={{
                                pathname: `/results/${searchid}/${finding.entity}`,
                                state: {
                                  from: `/landscape/riskprofile/${id}`
                                }
                              }}
                            >
                              <Badge
                                className='landscape-badge text-uppercase'
                                style={{
                                  background: COLOR_VALUES[i],
                                  color: '#fff'
                                }}
                              >
                                {uiLabel( finding.entity)}
                              </Badge>
                            </Link>
                          </DiscoveryTooltip>
                        ))}
                      </div>
                    </div>
                  );
                }
            })}

            <div className='mt-3'>
              <BsCircleFill className='mr-2' color='#315DFF'/>
              {totalPercent}% of scanned data flagged as sensitive
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default RiskCategories;
